<template>
    <button
        @click="invokeWishlistSidebar()"
        class="relative flex items-center lg:ml-6"
        :aria-label="$snippets['headless.header.openWishlist']">
        <HeartIcon class="size-5 stroke-2 duration-300 hover:text-green-500 lg:size-6" />
        <span class="count-label" v-if="wishlistCount > 0">{{ wishlistCount }}</span>
    </button>

    <ShopwareSidebar @close="invokeWishlistSidebar()" :open="sidebarOpen">
        <template #title>{{ $snippets['headless.wishlist.wishlist'] }} ({{ WishlistCount }})</template>
        <template #content>
            <ShopwareAccountWishlist @closeWishlist="invokeWishlistSidebar()" :isLoggedIn="isLoggedIn" />
        </template>
    </ShopwareSidebar>
</template>

<script setup lang="ts">
    import { HeartIcon } from '@heroicons/vue/24/outline';

    const { count: WishlistCount } = useUnifiedWishlist();
    const { isLoggedIn } = useUserExtended();
    const wishlistSidebarStore = useWishlistSidebarStore();
    const { invokeWishlistSidebar } = wishlistSidebarStore;
    const { sidebarOpen, refreshTrigger } = storeToRefs(wishlistSidebarStore);
    const { count: wishlistCount, getWishlistProducts: getUnifiedWishlistProducts } = useUnifiedWishlist();
    getUnifiedWishlistProducts();

    watch(refreshTrigger, async () => {
        await getUnifiedWishlistProducts();
    });

    onBeforeMount(async () => {
        // await refreshUserWithAssociations();
        await getUnifiedWishlistProducts();
    });
</script>
